/*global requirejs*/
requirejs.config({
	baseUrl: '/analytics-ui/static/',

	urlArgs: "v=" + Date.now(),

	paths: {
		'glu': 'bower_components/glu',
		'hbs': 'bower_components/glu/core/internal/hbs',
		'text': 'bower_components/glu/vendor/requirejs-text/text',
		'handlebars': 'bower_components/glu/vendor/handlebars/handlebars',
		'jquery': 'bower_components/glu/vendor/jquery/dist/jquery',
		'jui': 'bower_components/glu/vendor/jquery-ui/ui',
		'underscore': 'bower_components/glu/vendor/underscore/underscore',
		'backbone': 'bower_components/glu/vendor/backbone/backbone',
		'marionette': 'bower_components/glu/vendor/marionette/lib/core/amd/backbone.marionette',
		'backbone.wreqr': 'bower_components/glu/vendor/backbone.wreqr/lib/backbone.wreqr',
		'backbone.babysitter': 'bower_components/glu/vendor/backbone.babysitter/lib/backbone.babysitter',
		'moment': 'bower_components/glu/vendor/moment/moment',
		'd3': 'bower_components/glu/vendor/d3/d3',
		'c3': 'bower_components/glu/vendor/c3/c3',
		'select2': 'bower_components/glu/vendor/select2/select2',
		'rsvp': 'bower_components/glu/vendor/rsvp/rsvp.min',
		'numeral': 'bower_components/glu/vendor/numeral/numeral',
		'respond': 'bower_components/glu/vendor/respond/dest/respond.src',
		'bootstrap.tooltip': 'bower_components/glu/vendor/bootstrap/js/tooltip',
		'bootstrap.affix': 'bower_components/glu/vendor/bootstrap/js/affix',
		'bootstrap.alert': 'bower_components/glu/vendor/bootstrap/js/alert',
		'bootstrap.button': 'bower_components/glu/vendor/bootstrap/js/button',
		'bootstrap.collapse': 'bower_components/glu/vendor/bootstrap/js/collapse',
		'bootstrap.transition': 'bower_components/glu/vendor/bootstrap/js/transition',
		'bootstrap.dropdown': 'bower_components/glu/vendor/bootstrap/js/dropdown',
		'bootstrap.popover': 'bower_components/glu/vendor/bootstrap/js/popover',
		'bootstrap.scrollspy': 'bower_components/glu/vendor/bootstrap/js/scrollspy',
		'bootstrap.modal': 'bower_components/glu/vendor/bootstrap/js/modal',
		'bootstrap.tab': 'bower_components/glu/vendor/bootstrap/js/tab',
		'bootstrap-daterangepicker': 'bower_components/glu/vendor/bootstrap-daterangepicker/daterangepicker',
		'jquery-mask': 'bower_components/glu/vendor/jQuery-Mask-Plugin/dist/jquery.mask'

	},

	shim: {
		'select2': ['jquery'],
		'bootstrap.tooltip': ['jquery'],
		'bootstrap.affix': ['jquery'],
		'bootstrap.alert': ['jquery'],
		'bootstrap.button': ['jquery'],
		'bootstrap.transition': ['jquery'],
		'bootstrap.dropdown': ['jquery'],
		'bootstrap.collapse': ['jquery', 'bootstrap.transition'],
		'bootstrap.popover': ['jquery', 'bootstrap.tooltip'],
		'bootstrap.scrollspy': ['jquery'],
		'bootstrap.modal': ['jquery'],
		'bootstrap.tab': ['jquery'],
		'jquery-mask': ['jquery'],
		'bootstrap-daterangepicker': ['jquery']
	},

	map: {
		'*': {
			'glu/layout': 'common/baseLayout',
			'glu/itemView': 'common/baseItemView'
		},
		'common/baseLayout': {
			'glu/layout': 'glu/layout'
		},
		'common/baseItemView': {
			'glu/itemView': 'glu/itemView'
		}
	}

});


require(['glu/host', 'glu/http', './config', './app/app', './app/controller', './app/models/User', './app/router', './common/views/login/top', './app/nav/MasterTabView'], function(Host, http, config, App, Controller, User, Router, loginView, navView, Analytics) {
	'use strict';
	var host = new Host({
		app: '*'
	});

	var loadUserProfile = function() {
		App.user = new User();
		return App.user.fetch();
	};

	host.start();

	host.loadGuest(Router, Controller, {
		//carry promises into the module
		promises: [],
		afterAuthPromises: [loadUserProfile],
		//The view to deliver when this page encounters a 401 (Unauthorized) error
		loginView: loginView,
		//The view shown in the top bar of the application
		navView: navView,
		authTest: config.apiRoot + 'service/ping-authenticated',
		appRoot: config.baseUrl,
		title: 'Analytics',
		serverErrorHandler: function() {
			// We don't want to show a generic error messsage when a 500 error occurs.
		}
	});

});

define("init", function(){});

